import { Component, inject, output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  imports: [SHARED_IMPORTS],
})
export class ConfirmModalComponent {
  private readonly _modalDisplay =
    inject<MatDialogRef<ConfirmModalComponent>>(MatDialogRef);

  public title: string;
  public message: string;
  public action: string;
  public warn: string;
  public buttonColor: string = 'warn';

  readonly confirmationEvent = output<void>();

  confirm() {
    this._modalDisplay.close();
    // TODO: The 'emit' function requires a mandatory void argument
    this.confirmationEvent.emit();
  }
}
